module.exports = __webpack_public_path__ + "static/media/mail.15bed2a5.svg";